import { PRODUCTS } from 'Apps/Feedback/constants/feedbackSections';
import {
  haircareImprovements,
  haircareNoConcernInImprovements,
  haircareNoImprovements,
  haircareScalpSerumComfort,
  haircareSomeImprovements,
} from 'Apps/Feedback/constants/feedbackSlugs';

import { feedbackCategories } from 'constants/feedback';
import { productsSlugs } from 'constants/products';

const scalpSerumComfort = {
  name: haircareScalpSerumComfort,
  route: `/feedback/${feedbackCategories.HAIRCARE}/product_scalp_serum_comfort`,
  category: PRODUCTS,
  shouldBeIncluded: ({ formulas }) =>
    formulas?.find(f => f.variant.product.type === productsSlugs.SCALP_SERUM),
  title: 'Did your scalp feel more comfortable after using scalp serum?',
  subtitle: 'Consider how it feels now on a typical day.',
  options: [
    { value: haircareImprovements, label: "Yes, it's more comfortable now" },
    { value: haircareSomeImprovements, label: 'A little, but not enough' },
    { value: haircareNoImprovements, label: "No, it's still uncomfortable" },
    { value: haircareNoConcernInImprovements, label: "It wasn't a concern" },
  ],
  getInitialValue: answers => answers?.product_scalp_serum_comfort,
  getAnswers: ({ selected }) => ({ product_scalp_serum_comfort: selected }),
};

export default scalpSerumComfort;
